export abstract class StringToRecordConverter {
  static convert<T>(string: string | null | undefined) {
    if (string) {
      return JSON.parse(string) as Record<string, T>;
    }
    return {};
  }
}
